import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './Master.css';

const JudgeMaster = () => {
  const { judges, setJudges, courts, addAuditLog } = useApp();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    judgeName: '',
    designation: 'District Judge',
    courtId: '',
    benchName: '',
    email: '',
    contactNumber: '',
    joiningDate: '',
    tenure: '',
  });
  const [editingId, setEditingId] = useState(null);

  const designations = ['Chief Justice', 'Justice', 'District Judge', 'Session Judge', 'Magistrate'];

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const court = courts.find(c => c.id === formData.courtId);
    
    if (editingId) {
      setJudges(judges.map(judge => 
        judge.id === editingId 
          ? { ...judge, ...formData, courtName: court?.courtName || '' }
          : judge
      ));
      addAuditLog('Judge Updated', `Judge ${formData.judgeName} updated`);
    } else {
      const newJudge = {
        id: Date.now().toString(),
        ...formData,
        courtName: court?.courtName || '',
        createdAt: new Date().toISOString(),
      };
      setJudges([...judges, newJudge]);
      addAuditLog('Judge Added', `New judge ${formData.judgeName} added`);
    }
    
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      judgeName: '',
      designation: 'District Judge',
      courtId: '',
      benchName: '',
      email: '',
      contactNumber: '',
      joiningDate: '',
      tenure: '',
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleEdit = (judge) => {
    setFormData(judge);
    setEditingId(judge.id);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    const judge = judges.find(j => j.id === id);
    setJudges(judges.filter(j => j.id !== id));
    addAuditLog('Judge Deleted', `Judge ${judge.judgeName} deleted`);
  };

  return (
    <div className="master-container">
      <div className="master-header">
        <h1>👨‍⚖️ Judge Master</h1>
        <button onClick={() => setShowForm(!showForm)} className="btn-primary">
          {showForm ? 'Cancel' : '+ Add Judge'}
        </button>
      </div>

      {showForm && (
        <div className="master-form-card">
          <h2>{editingId ? 'Edit Judge' : 'Add New Judge'}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label>Judge Name *</label>
                <input
                  type="text"
                  value={formData.judgeName}
                  onChange={(e) => setFormData({...formData, judgeName: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Designation *</label>
                <select
                  value={formData.designation}
                  onChange={(e) => setFormData({...formData, designation: e.target.value})}
                  required
                >
                  {designations.map(des => (
                    <option key={des} value={des}>{des}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Court *</label>
                <select
                  value={formData.courtId}
                  onChange={(e) => setFormData({...formData, courtId: e.target.value})}
                  required
                >
                  <option value="">Select Court</option>
                  {courts.map(court => (
                    <option key={court.id} value={court.id}>{court.courtName}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Bench Name</label>
                <input
                  type="text"
                  value={formData.benchName}
                  onChange={(e) => setFormData({...formData, benchName: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Contact Number</label>
                <input
                  type="tel"
                  value={formData.contactNumber}
                  onChange={(e) => setFormData({...formData, contactNumber: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Joining Date</label>
                <input
                  type="date"
                  value={formData.joiningDate}
                  onChange={(e) => setFormData({...formData, joiningDate: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Tenure (Years)</label>
                <input
                  type="number"
                  value={formData.tenure}
                  onChange={(e) => setFormData({...formData, tenure: e.target.value})}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary">
                {editingId ? 'Update' : 'Add'} Judge
              </button>
              <button type="button" onClick={resetForm} className="btn-secondary">
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="master-table-card">
        <h2>Judge List ({judges.length})</h2>
        {judges.length > 0 ? (
          <div className="table-container">
            <table className="master-table">
              <thead>
                <tr>
                  <th>Judge Name</th>
                  <th>Designation</th>
                  <th>Court</th>
                  <th>Bench</th>
                  <th>Contact</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {judges.map(judge => (
                  <tr key={judge.id}>
                    <td><strong>{judge.judgeName}</strong></td>
                    <td>{judge.designation}</td>
                    <td>{judge.courtName}</td>
                    <td>{judge.benchName || 'N/A'}</td>
                    <td>{judge.contactNumber || 'N/A'}</td>
                    <td>
                      <button onClick={() => handleEdit(judge)} className="btn-edit">Edit</button>
                      <button onClick={() => handleDelete(judge.id)} className="btn-delete">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="empty-state">No judges added yet. Click "Add Judge" to get started.</p>
        )}
      </div>
    </div>
  );
};

export default JudgeMaster;

